import request from '@/utils/request'

export function uploadFile(type, data, config) {
  return request({
    url: `/fileobjects?type=${type}`,
    method: 'post',
    data,
    headers: config.headers,
    onUploadProgress: config.onUploadProgress
  })
}

export function updateEmptyFile(id, data, config) {
  if (config) {
    return request({
      url: `/fileobjects/${id}`,
      method: 'put',
      data,
      onUploadProgress: config.onUploadProgress,
      timeout: 0
    })
  } else {
    return request({
      url: `/fileobjects/${id}`,
      method: 'put',
      data
    })
  }
}

export function fileInfo(id) {
  return request({
    url: `/fileobjects/${id}`,
    method: 'get',
    errorMessage: false
  })
}

export function identifyFiles(number) {
  return request({
    url: `/fileobjects/identifier?n=${number}`,
    method: 'post'
  })
}

export function downloadFile(id, config, size) {
  const params = {
    size
  }
  if (config) {
    return request({
      url: `/fileobjects/${id}/content`,
      method: 'get',
      onDownloadProgress: config.onDownloadProgress,
      timeout: 0,
      errorMessage: false
    })
  } else {
    return request({
      url: `/fileobjects/${id}/content`,
      method: 'get',
      timeout: 0,
      params,
      errorMessage: false
    })
  }
}

export function downloadZipFile(fileList) {
  return request({
    url: `/fileobjects/0/zipcontent`,
    method: 'post',
    data: fileList,
    responseType: 'blob',
    errorMessage: false
  })
}

// 获取自定义图标
export function getIcon(id) {
  return request({
    url: `/smallfiles/${id}/file`,
    method: 'get'
  })
}

// 获取onlyoffice设置
export function getOnlyOfficeSetting() {
  return request({
    url: `/admin/settings/onlineoffice`,
    method: 'get'
  })
}
